const lang = {
  contact: 'Kontak',
  experience: 'Pengalaman',
  education: 'Pendidikan',
  skills: 'Keterampilan',
  about: 'Tentang Saya'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/id.js